import React, { Component } from "react";
import { Row, Col, Button, Alert } from "reactstrap";
import { Link } from "react-router-dom";
import { MdArrowBack, MdModeEdit, MdAutorenew } from "react-icons/md";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { cardSchemeActions } from "./actions/cardschemes.actions";

import { Spinner, Placeholder } from "../Shared";
import { routeConstants } from "../../_constants";

export class CardScheme extends Component {
  componentDidMount() {
    this.getCardScheme();
  }

  componentWillUnmount() {
    this.props.resetCardScheme();
  }

  getCardScheme = () => {
    const { match } = this.props;
    if (match.params && match.params.id) {
      this.props.getCardScheme(match.params.id);
    }
  };

  render() {
    const { match, response, fetching, error } = this.props;
    const cardScheme = response && response.modelList[0];

    return (
      <div>
        <Row>
          <Col sm="6">
            <Link
              className="btn btn-outline btn-primary"
              to={routeConstants.CARDSCHEMES.path}
            >
              <MdArrowBack /> Back to list
            </Link>
          </Col>
          <Col sm="6">
            <div className="text-right">
              <h5 className="item-count">
                <div>
                  Card Scheme: {cardScheme && cardScheme.code}{" "}
                  <Button
                    onClick={this.getCardScheme}
                    color="primary"
                    outline
                    disabled={fetching}
                  >
                    {fetching ? (
                      <Spinner />
                    ) : (
                      <div>
                        <MdAutorenew size={20} />
                      </div>
                    )}
                  </Button>
                </div>
              </h5>
            </div>
          </Col>
        </Row>
        <hr />
        <Row>
          <Col>
            {error && (
              <Alert color="danger">
                <strong>Error:</strong> {error.message}
              </Alert>
            )}

            <dl className="row">
              {/* <dt className="col-sm-3">Card Scheme Id</dt>
              <dd className="col-sm-9">
                {cardScheme ? (
                  cardScheme.id
                ) : (
                  <Placeholder text="Fetching data" blur={3} />
                )}
              </dd> */}

              <dt className="col-sm-3">Card Scheme Code</dt>
              <dd className="col-sm-9">
                {cardScheme ? (
                  cardScheme.code
                ) : (
                  <Placeholder text="Fetching data" blur={3} />
                )}
              </dd>

              <dt className="col-sm-3">Card Scheme Description</dt>
              <dd className="col-sm-9">
                {cardScheme ? (
                  cardScheme.description
                ) : (
                  <Placeholder text="Fetching data" blur={3} />
                )}
              </dd>
            </dl>
            <Link
              className="btn btn-primary"
              to={`${routeConstants.CARDSCHEMES.path}/edit/${match.params.id}`}
            >
              <MdModeEdit /> Edit
            </Link>
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { fetching, fetched, request, response, error } = state.viewCardScheme;
  return {
    fetching,
    fetched,
    request,
    response,
    error
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getCardScheme: bindActionCreators(
      cardSchemeActions.getCardScheme,
      dispatch
    ),
    resetCardScheme: bindActionCreators(
      cardSchemeActions.resetCardScheme,
      dispatch
    )
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CardScheme);
